/**
 * 广远调用接口
 *
 * */
export default class GuangYuanDao {
    /**
     * 开始学习接口
     *
     * @param  param   参数
     * @param  {Function} callback 请求成功的回调函数，参数为课件的数组
     * @return 无返回值
     */
    static startStudy(param, callback) {
        $.rest.create({ url: URLS_GY.START_STUDY, data: param, jsonRequestBody: true, json: true, success: (result) => {
            if (result.code == 200) {
                const data = result.data;
                callback(data);
            } else {
                Utils.warning('开始学习接口错误', result.msg);
            }
        },
        });
    }

    /**
     * 获取企业配置
     *
     * @Param authCode         // 授权码
     * @Param projectClassId   // 项目班级id
     * @param  {Function} callback 请求成功的回调函数，参数为试题的数组
     * @return 无返回值
     */
    static configUp(authCode, projectClassId, callback) {
        // console.log('获取企业配置');
        $.rest.get({ url: URLS_GY.CONFIG_UP, data: { authCode, projectClassId }, json: true, success: (result) => {
            if (result.code == 200) {
                const data = result.data;
                callback(data);
            } else {
                Utils.warning('获取企业配置接口错误', result.msg);
            }
        }, });
    }

    /**
     * 获取重学数据
     *
     * @Param authCode         // 授权码
     * @Param projectClassId   // 项目班级id
     * @param  {Function} callback 请求成功的回调函数，参数为课件的数组
     * @return 无返回值
     */
    static reLearnList(authCode, projectClassId, callback) {
        $.rest.create({ url: URLS_GY.RELEARN_LIST, data: { authCode, relativeProjectId:projectClassId }, jsonRequestBody: true, json: true, success: (result) => {
            if (result.code == 200) {
                const data = result.data;
                callback(data);
            } else {
                Utils.warning('获取重学数据错误', result.msg);
            }
        },
        });
    }

    /**
     * 发起时长变更通知
     *
     * @param  authCode     授权码
     * @param  deviceId     设备唯一标识：PC和H5和IOS取UUID,Android取MAC(需去除冒号)
     * @param  deviceType   设备类型：PC端= TYPE_PC，H5端=TYPE_H5，Android端= TYPE_ANDROID，IOS端= TYPE_IOS（请传入对应的类型代码）
     * @param  progressTime  上一次提交到本次提交的增量播放时长(单位：秒)
     * @param  relativeProjectId 项目班级id
     * @param  resCode           资源编码
     * @param  courseWareCode    课件编码
     * @param  {Function} callback 请求成功的回调函数，参数为课件的数组
     * @return 无返回值
     */
    static sendNotice(param, callback) {
        $.rest.create({ url: URLS_GY.SEND_NOTICE, data: param, jsonRequestBody: true, json: true, success: (result) => {
            if (result.code == 200) {
                const data = result.data;
                callback(data);
            } else {
                Utils.warning('发起时长变更通知异常', result.msg);
            }
        },
        });
    }

    /**
     * 发起人脸识别
     *
     * @param  authCode     授权码
     * @param  deviceId     设备唯一标识：PC和H5和IOS取UUID,Android取MAC(需去除冒号)
     * @param  deviceType   设备类型：PC端= TYPE_PC，H5端=TYPE_H5，Android端= TYPE_ANDROID，IOS端= TYPE_IOS（请传入对应的类型代码）
     * @param  relativeProjectId 项目班级id
     * @param  resCode           资源编码
     * @param  courseWareCode    课件编码
     * @param  {Function} callback 请求成功的回调函数，参数为课件的数组
     * @return 无返回值
     */
    static invokeFaceCompareConfig(param, callback) {
        $.rest.create({ url: URLS_GY.FACE_COMPARE_CONFIG, data: param, jsonRequestBody: true, json: true, success: (result) => {
            const data = result;
            callback(data);
        },
        });
    }

    /**
     * 人脸识别
     *
     * @param  authCode     授权码
     * @param  bizCode      发起人脸识别，返回的code
     * @param  compareMode  0 = base 64纯比较， 1 = 纯网络地址路径比较， 2 = base64 和网络地址混合比暂时支持2
     * @param  deviceId     设备唯一标识：PC和H5和IOS取UUID,Android取MAC(需去除冒号)
     * @param  deviceType   设备类型：PC端= TYPE_PC，H5端=TYPE_H5，Android端= TYPE_ANDROID，IOS端= TYPE_IOS（请传入对应的类型代码）
     * @param  relativeProjectId 项目班级id
     * @param  target         图片链接或者base64 暂时使用base64
     * @param  videoStudyTime 当前提交人脸识别时，视频的观看时间点(单位：秒)
     * @param  resCode        资源编码
     * @param  courseWareCode 课件编码
     * @param  {Function} callback 请求成功的回调函数，参数为课件的数组
     * @return 无返回值
     */
    static invokeFaceCompare(param, callback) {
        $.rest.create({ url: URLS_GY.FACE_COMPARE, data: param, jsonRequestBody: true, json: true, success: (result) => {
            const data = result;
            callback(data);
        },
        });
    }

    /**
     * 获取弹窗验证
     *
     * @param  authCode     授权码
     * @param  deviceId     设备唯一标识：PC和H5和IOS取UUID,Android取MAC(需去除冒号)
     * @param  deviceType   设备类型：PC端= TYPE_PC，H5端=TYPE_H5，Android端= TYPE_ANDROID，IOS端= TYPE_IOS（请传入对应的类型代码）
     * @param  relativeProjectId 项目班级id
     * @param  resCode           资源编码
     * @param  courseWareCode    课件编码
     * @param  {Function} callback 请求成功的回调函数，参数为课件的数组
     * @return 无返回值
     */
    static invokeVerificationCode(param, callback) {
        $.rest.create({ url: URLS_GY.VERIFICATION_CODE, data: param, jsonRequestBody: true, json: true, success: (result) => {
            const data = result;
            callback(data);
        },
        });
    }

    /**
     * 提交校验验证码
     *
     * @param  authCode     授权码
     * @param  bizCode      发起人脸识别，返回的code
     * @param  deviceId     设备唯一标识：PC和H5和IOS取UUID,Android取MAC(需去除冒号)
     * @param  deviceType   设备类型：PC端= TYPE_PC，H5端=TYPE_H5，Android端= TYPE_ANDROID，IOS端= TYPE_IOS（请传入对应的类型代码）
     * @param  verificationCode 验证码
     * @param  videoStudyTime 当前提交人脸识别时，视频的观看时间点(单位：秒)
     * @param  courseWareCode 课件编码
     * @param  {Function} callback 请求成功的回调函数，参数为课件的数组
     * @return 无返回值
     */
    static invokeVerifyCode(param, callback) {
        $.rest.create({ url: URLS_GY.VERIFY_CODE, data: param, jsonRequestBody: true, json: true, success: (result) => {
            const data = result;
            callback(data);
        },
        });
    }

    /**
     * 录制视频提交
     *
     * @param  authCode     授权码
     * @param  courseCode   课程编码
     * @param  deviceId     设备唯一标识：PC和H5和IOS取UUID,Android取MAC(需去除冒号)
     * @param  deviceType   设备类型：PC端= TYPE_PC，H5端=TYPE_H5，Android端= TYPE_ANDROID，IOS端= TYPE_IOS（请传入对应的类型代码）
     * @param  recordVideoUrl 视频地址
     * @param  relativeProjectId 项目班级id
     * @param  resCode     资源编码
     * @param  sectionCode 章节编码
     * @param  courseWareCode 课件编码
     * @param  {Function} callback 请求成功的回调函数，参数为课件的数组
     * @return 无返回值
     */
    static invokeSubmitVideo(param, callback) {
        $.rest.create({ url: URLS_GY.SUBMIT_VIDEO, data: param, jsonRequestBody: true, json: true, success: (result) => {
            const data = result;
            callback(data);
        },
        });
    }
}
